import {ChangeDetectorRef, Component, OnInit, ViewEncapsulation, WritableSignal} from "@angular/core";
import { Fade, MedID, MedOptionType } from "@mk/med-ui";
import { ActivatedRoute, Router } from "@angular/router";
import { DistributionController } from "@app/ui_controllers/distributionController";
import {
  DistributionPageDto,
  DistributionRegionRecipientDto,
  RegistryDozSpecificationDto,
} from "@app/ui_models/web-response";
import {
  DistributionBeneficiaryDto,
  DistributionGoodDto,
  DistributionQuantityRequest,
  DistributionSendToDozRequest,
  GoodsLovControlDateDto,
} from "@app/ui_models/model-dto";
import { catchError, Observable, Subject } from "rxjs";
import { MedNotificationService } from "@mk/med-notification";
import { DataService } from "@app/services/data.service";
import { MedInputStateType } from "@mk/med-ui/lib/components/form/FieldCoreComponent";
import {tabHeader2, mnnTabHeader2, attachmentsTabHeader2, datesTabHeader2, componentsTabHeader} from "./column-headers";
import { tabHeader2 as tabHeaderDoz } from "@app/components/distribution/doz/column-headers";
import { DownloadService } from "@app/services/download.service";
import { env } from "@environments/environment";
import { DocumentFileApiService } from "@app/services/document.file.api.service";
import { DistributionDocument, FileAttachment, FileCreationResponse } from "@app/ui_models/document.service.models";
import { AccountService } from "@app/services/account.service";
import { DocumentsController } from "@app/ui_controllers/documents.controller";
import { StatusTranslatorService } from "@app/services/status.translator.service";
import {BeneficiaryController} from "@app/ui_controllers/beneficiaryController";
import {TableColResizeEvent} from "primeng/table";
@Component({
  selector: "app-distribution",
  templateUrl: "./distribution.component.html",
  styleUrls: ["/distribution.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: Fade,
})
export class DistributionComponent implements OnInit {
  constructor(private readonly router: Router,
              private readonly route: ActivatedRoute,
              private readonly distributionController: DistributionController,
              private readonly notificationService: MedNotificationService,
              private readonly dataService: DataService,
              public readonly downloadService: DownloadService,
              private readonly documentFileApiService: DocumentFileApiService,
              private readonly accountService: AccountService,
              private readonly documentsController: DocumentsController,
              private readonly beneficiaryController: BeneficiaryController,
              public statusTranslatorService: StatusTranslatorService) {
  }
  tableDistributionGood: DistributionGoodDto[] | undefined  = [];
  tableRegionRecipient: DistributionRegionRecipientDto[] | undefined = [];
  tabHeader: { label: string; key: string; width: string }[] = tabHeader2;
  mnnTabHeader: { label: string; key: string; }[] = mnnTabHeader2;
  attachmentsTabHeader: { label: string; key: string; }[] = attachmentsTabHeader2;
  componentsTabHeader: { label: string; key: string; }[] = componentsTabHeader;
  datesTabHeader: { label: string; key: string; }[] = datesTabHeader2;
  optionsTabGroup: MedOptionType<DistributionGoodDto>[] = [];
  optionsModel: DistributionGoodDto | null = null;
  distributionId = 0;
  distribution: DistributionPageDto | null = null;
  provisionCoefficientModal = false;
  attachmentsModal = false;
  componentsModal = false;
  reviewModal = false;
  distributionAgreementModal = false;
  backToDraftConfirmationModal = false;
  loadingCounter = 0;
  toAgree = true;
  sendToDOZModal = false;
  activeDistributionGoodId: number | undefined | null = 0;
  newProvisionCoefficient: number | null = 0;
  goodsLovControlDateList: GoodsLovControlDateDto[] = [];
  options: MedOptionType<any>[] = [{ label: "Наказ", value: "Наказ" }, { label: "Протокол", value: "Протокол" }];
  downloadReportOptions: MedOptionType<any>[] = [{ label: "Звичайний - базова структура без додаткових полів", value: 1 }, { label: "Розширений - з додатковими даними для розширеноі оброботки ", value: 2 }];
  value = 1;
  distributionGoodIdsWithStatuses = {};
  READONLY = false;
  validations = {};
  updateRemnantsInProgress = false;
  updateDistribution100FinancedInProgress = false;
  showRegionTable = false;
  distributionForRegion: DistributionPageDto = {} as DistributionPageDto;
  distributionForRegions: DistributionPageDto[] = [];
  tabHeaderDoz: { label: string; key: string; }[] = tabHeaderDoz;
  attachments = { content: [], isLoading: false };
  components = {content: [], isLoading: false};
  fileAttachments: FileAttachment[] = [];
  activeFileAttachment: FileAttachment = {} as FileAttachment;
  sendingToDOZ = false;
  isAddAttachmentDisabled = false;
  protected readonly alert = alert;
  downloadExcelModal: boolean | WritableSignal<boolean> = false;
  downloadReportValue: Number = 1;
  removePostponedModal = false;
  beneficiaryForRemovePostponed: DistributionBeneficiaryDto = {} as DistributionBeneficiaryDto;
  fileAttachmentsDateState: MedInputStateType = "";
  private pendingHides: { hide: Function; context?: any }[] = [];
  private debounceTimer: ReturnType<typeof setTimeout> | null = null;

  ngOnInit(): void {
    const routeId = this.route.snapshot.paramMap.get("id");
    if (!routeId) {
      return;
    }
    this.distributionId = Number(routeId);
    this.loadingCounter++;
    this.distributionController.getDistribution(this.distributionId).subscribe(data => {
      this.distribution = data["distribution"] as DistributionPageDto;
      if (data["distributionDozDtos"]) {
        this.distributionForRegions = data["distributionDozDtos"];
      }
      if (this.distribution.distributionGoods.length < 1) {
        return;
      }
      this.activeDistributionGoodId = this.distribution.distributionGoods[0].distributionGoodsId;
      this.tableRegionRecipient = this.distribution.regionRecipients.filter((item: DistributionRegionRecipientDto) => item.distributionGoodsId === this.activeDistributionGoodId);
      if (this.tableRegionRecipient) {
        this.tableRegionRecipient.sort((a, b) => a.regionName.localeCompare(b.regionName));
      }
      this.tableDistributionGood = this.distribution.distributionGoods;
      this.mapDistributionGoodIdsOnStatuses(this.distribution.distributionGoods);
      this.goodsLovControlDateList = this.setGoodsLovControlDateList(this.distribution.distributionGoods);
      this.distribution.distributionGoods.forEach((distr: DistributionGoodDto) => {
        this.optionsTabGroup.push({ value: distr, label: distr.mnnName });
      });
      this.optionsModel = this.optionsTabGroup[0].value;
      this.setAccess(this.distribution.status);
      if (this.distribution.components && this.distribution.components.length > 0) {
        this.components.content = this.distribution.components[0];
      }
      this.fileAttachments = [];
      const fileAttachment: FileAttachment = {} as FileAttachment;
      fileAttachment.selectedDate = new Date();
      fileAttachment.type = "Наказ";
      if (this.distribution) {
        fileAttachment.number = this.distribution.orderName;
      }
      this.activeFileAttachment = fileAttachment;
      this.fileAttachments.push(fileAttachment);
      this.loadingCounter--;
      // this.getDistributionDozDtos();
    });
    this.loadColumnOrder("distributionColumnOrder", "tabHeader");
    this.loadColumnOrder("mnnColumnOrder", "mnnTabHeader");
    this.loadColumnOrder("attachemntsColumnOrder", "attachmentsTabHeader");
    this.loadColumnOrder("componentsColumnOrder", "componentsTabHeader");
    this.loadColumnOrder("datesColumnOrder", "datesTabHeader");
    this.getAttachmentsMetaData();
    this.validateBeforeSendingToDOZ();
  }

  saveColumnOrder(key: string, tabHeader: any[]) {
    localStorage.setItem(key, JSON.stringify(tabHeader));
  }

  loadColumnOrder(key: string, tabHeader: keyof this) {
    const savedOrder = localStorage.getItem(key);
    if (savedOrder) {
      this[tabHeader] = JSON.parse(savedOrder);
    }
  }

  setGoodsLovControlDateList(goods:DistributionGoodDto[]): GoodsLovControlDateDto[] {
    const existLov: number[] = [];
    const goodsLovControlDateList: GoodsLovControlDateDto[] = [];
    goods.forEach(good => {
      if (!existLov.includes(good.lovId)) {
        existLov.push(good.lovId);
        goodsLovControlDateList.push({ distributionId: this.distributionId, lovId: good.lovId, controlDate: "", mnnId: good.mnnId, mnnName: good.mnnName, clientValidationState: "" });
      }
    });
    return goodsLovControlDateList;
  }

  setAccess(distributionStatus: string) {
    if (this.dataService.isMZU() && ("DRAFT") !== distributionStatus) {
      this.READONLY = true;
    }

    if (this.dataService.isMZU() && distributionStatus === "PENDING_APPROVAL") {
      this.toAgree = false;
    }
  }

  mapDistributionGoodIdsOnStatuses(dtos: DistributionGoodDto[] | undefined): void {
    this.distributionGoodIdsWithStatuses = {};
    if (!dtos) {
      return;
    }
    dtos.forEach(dto => {
      // @ts-ignore
      this.distributionGoodIdsWithStatuses[dto.distributionGoodsId ? dto.distributionGoodsId : "_._"] = dto.checked;
    });
  }

  isDistributionGoodChecked(distributionGoodsId: number | null): boolean {
    if (!distributionGoodsId) {
      return false;
    }
    // @ts-ignore
    return this.distributionGoodIdsWithStatuses[distributionGoodsId];
  }

  getPathToStatusImgTop(rowElement: string | undefined): string {
    let color: string;
    switch (rowElement) {
      case "DRAFT": color = "grey"; break;
      case "PENDING_APPROVAL": color = "yellow"; break;
      case "AWAITING_DOZ_DISTRIBUTION": color = "yellow"; break;
      default: color = "green";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  getPathToStatusImg(rowElement: string): string {
    let color: string;
    if (rowElement === "draft") {
      color = "grey";
    } else {
      color = "green";
    }
    return `assets/icons/table/Statys_indicator_${color}.png`;
  }

  tabGroupChanged($event: DistributionGoodDto | null): void {
    this.activeDistributionGoodId = $event?.distributionGoodsId;
    this.tableRegionRecipient = this.distribution?.regionRecipients.filter((item: DistributionRegionRecipientDto) => item.distributionGoodsId === this.activeDistributionGoodId);
    if (this.tableRegionRecipient) {
      this.tableRegionRecipient.sort((a, b) => a.regionName.localeCompare(b.regionName));
    }
  }

  goToSeries(): void {
    this.router.navigate(["/distribution/series/" + this.distributionId]);
  }

  save(): void {
    if (this.distributionHasValidationErrors()) {
      this.notificationService.error("Розподіл містить помилки валідації");
      return;
    }
    this.distributionController.updateDistributionQuantity(this.createUpdateQuantityRequestData())
      .pipe(
        catchError(response => {
          this.notificationService.error(JSON.parse(response.error).detail);
          this.invalidateAllInputsWithValues();
          throw response;
        }),
      ).subscribe(() => {
        this.reloadComponent("Розподіл збережено");
      });

  }

  invalidateAllInputsWithValues(): void {
    this.validations = [];
    this.tableRegionRecipient?.forEach(tableRegionRecipient => {
      if (tableRegionRecipient.distributedQuantity > 0) {
        // @ts-ignore
        this.validations[tableRegionRecipient.id] = "error";
        console.log(this.validations)
      }
    })
  }


  backToDraft(): void {
    this.distributionController.backToDraft(this.distributionId)
      .pipe(
        catchError(response => {
          this.notificationService.error(JSON.parse(response.error).detail);
          throw response;
        }),
      ).subscribe(() => {
        this.reloadComponent("Розподіл повернено на доопрацювання");
      });

  }

  createUpdateQuantityRequestData(): DistributionQuantityRequest[] {
    const quantities: DistributionQuantityRequest[] = [];

    if (this.tableRegionRecipient) {
      this.tableRegionRecipient.forEach(recipient => {
        if (recipient.active) {
          const quantityRequest: DistributionQuantityRequest = {
            id: recipient.id,
            distributionGoodsId: recipient.distributionGoodsId,
            distributedQuantity: Number(recipient.distributedQuantity),
          };
          quantities.push(quantityRequest);
        }
      });
    }

    return quantities;
  }

  activateRegionRecipient(regionRecipientId: number, active: boolean): void {
    this.distributionController.regionActivation(regionRecipientId, active).subscribe(() => {
      this.reloadComponent("Розподіл перераховано");
    });
  }

  removeDistributionGood(distributionGoodId: number) {
    this.distributionController.removeDistributionGood(distributionGoodId).subscribe(() => {
      this.reloadComponent();
    });
  }

  checkDistributionGood(distributionGoodId: number, checked : boolean) {
    this.distributionController.checkDistributionGood(distributionGoodId, !checked).subscribe(() => {
      const checkedText = !checked ? "перевірено" : "статус 'перевірено' знято";
      this.reloadComponent("МНН " + checkedText);
    });
  }

  distributeAll() {
    if (this.activeDistributionGoodId === undefined || this.activeDistributionGoodId === null) {
      return;
    }
    this.distributionController.distributeAll(this.activeDistributionGoodId).subscribe(() => {
      this.reloadComponent();
    });
  }

  validateBeforeSendingToDOZ(): Observable<string> {
    const subject = new Subject<string>();
    let validationMessage = "";
    // todo: uncomment before release
    // if (!this.distribution?.orderName) {
    //   validationMessage = " - Вкажіть номер розподілу. \n";
    // }
    if (!this.distribution?.updatedAt) {
      validationMessage += "Вкажіть дату розподілу. \n";
    }
    setTimeout(() => {
      subject.next(validationMessage);
      subject.complete();
    }, 200)

    return subject.asObservable();
    // todo: uncomment before release
    // this.documentFileApiService.getList(this.distribution?.documentId as MedID).subscribe(data => {
    //   console.log(data);
    //   if (data && data["content"] && data["content"].length < 1) {
    //     validationMessage += " - Підвантажте принаймні 1 файл (наказ або протокол) до розподілу. \n";
    //     console.log(validationMessage);
    //   }
    //   subject.next(validationMessage);
    //   subject.complete();
    // });
    // return subject.asObservable();
  }

  sendToDoz() {
    this.sendingToDOZ = true;
    this.validateBeforeSendingToDOZ().subscribe(data => {
      console.log(data);
      if (data) {
        this.notificationService.error(data);
        this.sendingToDOZ = false;
      } else {
        const goodsLovControlDateListFilled = this.goodsLovControlDateList.filter((item: GoodsLovControlDateDto) => item.controlDate !== "");

        const request: DistributionSendToDozRequest = {
          id: this.distributionId,
          goodsLovControlDateList: goodsLovControlDateListFilled,
        };
        this.distributionController.sendToDoz(request).subscribe(() => {
          this.sendingToDOZ = false;
          this.router.navigate(["/distributions/mzu"]);
        });
      }
    });
  }

  approve(): void {
    if (this.distributionHasValidationErrors()) {
      this.notificationService.error("Розподіл містить помилки валідації");
      return;
    }
    this.distributionController.approve(this.createUpdateQuantityRequestData())
      .pipe(
        catchError(response => {
          this.notificationService.error(JSON.parse(response.error).detail);
          throw response;
        }),
      ).subscribe(() => {
        this.distributionAgreementModal = false;
        this.toAgree = false;
        this.reloadComponent("Розподіл відправлено на погодження");
      });

  }

  editProvisionCoefficient(): void {
    if (this.activeDistributionGoodId === undefined || this.activeDistributionGoodId === null || this.newProvisionCoefficient === null) {
      return;
    }

    this.provisionCoefficientModal = false;
    this.distributionController.updateCoefficient(this.activeDistributionGoodId, this.newProvisionCoefficient).subscribe(() => {
      this.reloadComponent();
    });
  }

  isAnyDistributionGoodIdChecked(): boolean {
    if (!this.tableDistributionGood) {
      return false;
    }
    return this.tableDistributionGood.some(i => i.checked);
  }

  reloadComponent(text?: string) {
    const { url } = this.router;
    this.router.navigateByUrl("/refreshing", { skipLocationChange: true }).then(() => {
      this.router.navigate([`/${url}`]).then(() => {
        if (text) {
          this.notificationService.success(text);
        }
      });
    });
  }

  getStatus(): string {
    if (!this.distribution) {
      return "";
    }
    return this.statusTranslatorService.getStatusForString(this.distribution.status);
  }

  validateRegion(row: DistributionRegionRecipientDto): boolean {
    const recipientGood:DistributionGoodDto | undefined = this.tableDistributionGood?.filter((item: DistributionGoodDto) =>
      item.distributionGoodsId === this.activeDistributionGoodId)[0];
    if (!recipientGood) {
      throw new Error("Active good not found");
    }
    if (row.distributedQuantity % 1 === 0 &&
      row.distributedQuantity >= 0 &&
      row.distributedQuantity < 2147483647) {
      // @ts-ignore
      this.validations[row.id] = "success";
      Object.entries(this.validations).forEach(([key, value]) => {
        if(value === "error") {
          // @ts-ignore
          this.validations[key] = "success";
        }
      })
      return true;
    }
    // @ts-ignore
    this.validations[row.id] = "error";
    return false;

  }

  getValidationState(id: number): MedInputStateType {
    // @ts-ignore
    return this.validations[id];
  }

  distributionHasValidationErrors(): boolean {
    // @ts-ignore
    return Object.keys(this.validations).some(key => this.validations[key] === "error");
  }

  mnnHasValidationErrors(distributionGoodsId: number): boolean {
    let retValue = false;
    this.distribution?.regionRecipients
      .filter((item: DistributionRegionRecipientDto) => item.distributionGoodsId === distributionGoodsId)
      .forEach(region => {
        if (this.validations.hasOwnProperty(region.id) && !retValue) {
          // @ts-ignore
          retValue = this.validations[region.id] === "error";
        }
      });
    return retValue;
  }

  updateDistribution100Financed() {
    if (this.activeDistributionGoodId) {
      this.updateDistribution100FinancedInProgress = true;
      this.distributionController.updateDistribution100Financed(this.activeDistributionGoodId, this.distributionId).subscribe(() => {
        this.updateDistribution100FinancedInProgress = false;
        this.reloadComponent("Значення '100% потреба профінансовано' оновлено для всіх регіонів");
      });
    }
  }

  updateRemnants() {
    if (this.activeDistributionGoodId) {
      this.updateRemnantsInProgress = true;
      this.distributionController.updateRemnants(this.activeDistributionGoodId, this.distributionId).subscribe(() => {
        this.updateRemnantsInProgress = false;
        this.reloadComponent("Значення 'Залишки' оновлено для всіх регіонів");
      });
    }
  }

  archive() {
    this.distributionController.archive(this.distributionId).subscribe(() => {
      this.reloadComponent("Розподіл заархівовано");
    });
  }

  showRegionTabl(regionId: number) {
    this.showRegionTable = true;
    this.distributionController.getDistributionDozForRegion(this.distributionId, regionId).subscribe(distribution => {
      this.distributionForRegion = distribution;
    });
  }

  getAllRegionIds(): number[] {
    const retValue: number[] = [];
    this.distribution?.regionRecipients?.forEach(region => {
      if (region.regionId) {
        retValue.push(region.regionId);
      }
    });
    return retValue;
  }

  getDistributionDozDtos(): void {
    this.distributionController
      .getDistributionDozForRegions(this.distributionId, this.getAllRegionIds())
      .subscribe(data => {
        this.distributionForRegions = data;
      });
  }

  getBeneficiarByRegionId(regionId: number): DistributionBeneficiaryDto[] {
    let retValue: DistributionBeneficiaryDto[] = [];
    const distrPageDTO: DistributionPageDto | undefined = this.distributionForRegions.find(distr => distr.region?.id === regionId);
    if (distrPageDTO) {
      if (distrPageDTO.goodSpecifications) {
        const dto: RegistryDozSpecificationDto | undefined = distrPageDTO.goodSpecifications.find((goodSpec: any) => goodSpec.good.mnnId === this.optionsModel?.mnnId);
        if (dto) {
          retValue = dto.beneficiaries || [];
        }
      }
    }
    return retValue;
  }

  openDownloadExcelModal() {
    this.downloadExcelModal = true;
    this.downloadReportValue = 1;
  }

  downloadExcel() {
    const baseUrl = `${env.logisticsServiceBackend}/logistics/v1/distributions/export/`;
    if (this.downloadReportValue === 1) {
      this.downloadService.download(baseUrl + this.distributionId + "?type=SUMMARY", null, null, "distribution_" + this.distributionId + ".xlsx");
    } else {
      this.downloadService.download(baseUrl + this.distributionId + "?type=FULL", null, null, "distribution_" + this.distributionId + ".xlsx");
    }
  }

  onFileInput(file: string | File, i?: number): void {
    if (!file) {
      return;
    }

    // const { name: fileName } = (file as File);
    // // @ts-ignore
    // const subject = new BehaviorSubject<Document.File | null>(null);

    const data = new FormData();
    data.append("file", file);
    // // @ts-ignore
    // data.append("headers", { "downloadedBy": "MZU" });

    this.documentFileApiService.uploadFile(this.distribution?.documentId as MedID, data).subscribe(data => {
      const dat = data as any;
      if (dat && dat.body) {
        const response: FileCreationResponse = dat.body as FileCreationResponse;
        if (response) {
          const fileDocument: DistributionDocument = {} as DistributionDocument;
          fileDocument.fileId = response.id + "";
          fileDocument.distributionId = this.distributionId;
          fileDocument.fileName = response.filename;
          fileDocument.type = this.activeFileAttachment.type;
          fileDocument.selectedDate = this.activeFileAttachment.selectedDate;
          fileDocument.fileNumber = this.activeFileAttachment.number;
          fileDocument.lastUpdate = response.modifiedAt;
          fileDocument.owner = this.accountService.organizationShortName();

          this.documentsController.createFileInDocument(fileDocument).subscribe(() => {
            this.notificationService.success(`Файл '${fileDocument.fileName}' завантажено`);
            if (this.distribution) {
              this.distribution.orderName = this.activeFileAttachment.number;
            }
            this.getAttachmentsMetaData();
            if (typeof i === "number") {
              this.fileAttachments[i].isFileAdded = true;
            }
            this.isAddAttachmentDisabled = false;
          });
        }
      }
    });

    // subject.pipe(untilDestroyed(this)).subscribe({
    //   next: body => {
    //     if (!body) {
    //       return;
    //     }
    //     this.tableData.updateItem(body, index);
    //   },
    //   error: e => {
    //     logger.error(e);
    //     this.tableData.updateItem({}, index);
    //   },
    // });
  }

  openAttachmentsModal() {
    this.attachments.isLoading = true;
    this.attachmentsModal = true;
    this.documentsController.getAllForDistribution(this.distributionId).subscribe(data => {
      // @ts-ignore
      this.attachments.content = data;
      this.attachments.isLoading = false;
    });
    // this.documentFileApiService.getList(this.distribution?.documentId as MedID).subscribe(data => {
    //   this.attachments.content = data["content"];
    //   this.attachments.isLoading = false;
    // });
  }

  openComponentsModal() {
    this.componentsModal = true;
  }

  getAttachmentsMetaData() {
    this.documentsController.getAllForDistribution(this.distributionId).subscribe(data => {
      // @ts-ignore
      this.attachments.content = data;
    });

  }

  downloadFile(row: DistributionDocument) {
    const url = this.documentFileApiService.getBaseUrl() + `/${row.fileId}/files`;
    this.downloadService.download(url, null, null, row.fileName);
  }

  addFileAttachment() {
    const attachment = {} as FileAttachment;
    // @ts-ignore
    attachment.number = this.fileAttachments[0].number;
    attachment.selectedDate = this.fileAttachments[0].selectedDate;
    attachment.type = this.fileAttachments[0].type;
    // this.activeFileAttachment = attachment;
    this.fileAttachments.push(attachment);
    // this.isAddAttachmentDisabled = true;
    console.log(this.fileAttachments)
  }

  showSentToDozModal() {
    this.sendToDOZModal = true;

    this.toggleModal(true);
  }

  closeSendToDozModal() {
    this.sendToDOZModal = false;
    this.toggleModal(false);
  }

  deleteAttachment() {
    // const otherAttachments = this.fileAttachments.filter((_, index) => index !== i);
    // this.isAddAttachmentDisabled = !otherAttachments.every(item => item.isFileAdded);
    this.fileAttachments.pop();
  }

  toggleModal(open: boolean) {
    this.sendToDOZModal = open;
    if (open) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }

  cancelDownloadReport() {
    this.downloadExcelModal = false;
  }

  downloadReportOptionChanged($event: any) {
    this.downloadReportValue = $event;
  }

  removePostponed(): void {
    if (this.beneficiaryForRemovePostponed.id) {
      this.beneficiaryController.withdrawPostponed(this.beneficiaryForRemovePostponed.id).subscribe(() => {
        this.notificationService.success("Відтермінування було скасовано. Товар повернуто до активного розподілу")
        this.beneficiaryForRemovePostponed.postponedActive = false;
        this.removePostponedModal = false;
      })
    }
  }

  showRemovePostponedModal(beneficiary: DistributionBeneficiaryDto): void {
    console.log(beneficiary);
    this.beneficiaryForRemovePostponed = beneficiary;
    this.removePostponedModal = true;
  }

  handleColumnResize($event: TableColResizeEvent) {
    this.tabHeader.forEach(element => {
      if (element.label === $event.element.innerText.trim()) {
        element.width = $event.element.clientWidth + "px";
      }
    })
    this.saveColumnOrder("distributionColumnOrder", this.tabHeader);
  }

  validateFileAttachmentDate(newDate: Date) {
    console.log(newDate);
    console.log("validate date")

    let selectedDate: number = newDate.getTime();
    let today: number = new Date().getTime();

    if (selectedDate > today) {
      this.notificationService.error("Оберіть дату в минулому або сьогодні");
      this.fileAttachmentsDateState = "error";
    } else {
      this.fileAttachmentsDateState = "success";
    }
  }

  validateControlDate(newDate: Date, row: GoodsLovControlDateDto) {
    console.log(newDate);
    console.log("validate date")

    let selectedDate: number = newDate.getTime();
    let today: number = new Date().getTime();

    if (selectedDate > today) {
      this.notificationService.error("Оберіть дату в минулому або сьогодні");
      row.clientValidationState = "error";
    } else {
      row.clientValidationState = "success";
    }
  }

  debouncePanel(hide: Function, context?: any) {
    const flush = (items: { hide: Function; context?: any }[]) => {
      items.forEach(item => {
        try {
          console.log("debouncePanel hide", item);
          item.hide.call(item.context);
        } catch (e) {
          console.error("debouncePanel hide error", e);
        }
      });
    };

    console.log(this.pendingHides.length + " pending hides");

    // If there are already pending items, execute them immediately and remove them
    if (this.pendingHides.length > 0) {
      const existing = this.pendingHides.splice(0, this.pendingHides.length);
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = null;
      }
      flush(existing);
    }

    // Store current call and (re)start debounce timer to execute it after 2s
    this.pendingHides.push({ hide, context });

    this.debounceTimer = setTimeout(() => {
      const toFlush = this.pendingHides.splice(0, this.pendingHides.length);
      this.debounceTimer = null;
      flush(toFlush);
    }, 2000);
  }


}
